export default __webpack_public_path__ + "static/media/try-atomic-energy-display.306d19f6.png";